export enum Environment {
	DEVELOPMENT = 'dev',
	PRODUCTION = 'prd',
}
